export default __webpack_public_path__ + "static/media/select-docked-menu.542ef3e0.svg";